import { render, staticRenderFns } from "./OriginalTipsDialog.vue?vue&type=template&id=352898b6&scoped=true"
import script from "./OriginalTipsDialog.vue?vue&type=script&lang=js"
export * from "./OriginalTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./OriginalTipsDialog.vue?vue&type=style&index=0&id=352898b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352898b6",
  null
  
)

export default component.exports